import type { PropsWithChildren } from 'react';
import React from 'react';
import { Box, Text } from '@usealloy/component-library';
import { MatchDatumlLink } from './styles';

const TextWrapper = ({ label, children }: PropsWithChildren<{ label: string }>) => (
  <Box direction="column" alignItems="flex-start" gap={2}>
    <Text size={2} lineHeight={3} style={{ color: 'var(--cl-gray-700)' }}>{label}</Text>
    {children}
  </Box>
);

export const MatchDatum = ({ label, children }: PropsWithChildren<{ label: string }>) => {
  if (typeof children !== 'string') {
    return (
      <TextWrapper label={label}>
        <Text size={2} lineHeight={3}>
          {children}
        </Text>
      </TextWrapper>
    );
  }
  return (
    <TextWrapper label={label}>
      <Text size={2} lineHeight={3}>{
        children
          .split(/(https?:\/\/[^\s]+)/)
          .map(each => {
            if (!each.startsWith('http')) return each;
            return (
              <MatchDatumlLink
                key={`${each}-link-${Math.random()}`}
                target="_blank"
                href={each}
              >{each}
              </MatchDatumlLink>
            );
          })
      }
      </Text>
    </TextWrapper>
  );
};
